import { eventBus } from './eventBusService'
export class GlobalErrorHandler {
  handleError(error: any): void {
    if (error.isAxiosError) {
      eventBus.emit('alertMessage', 'Something went wrong!')
    } else {
      console.error('An unexpected error occurred:', error)
    }
  }
}
export default new GlobalErrorHandler()
